import { Alert } from 'antd';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

import GoogleSignInButton from '../UI/GoogleSignInButton/GoogleSignInButton';

const Container = styled.div`
  height: 100%;
  width: 100%;
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;

  .alert {
    margin: 11px 0;
    width: 300px;
  }

  .center-box {
    border: 1px solid #e4e4e4;
    background: #fff;
    border-radius: 3px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    padding: 40px 40px 50px;
  }

  .logo {
    font-weight: 900;
    font-size: 87px;
    letter-spacing: -3px;
    text-align: center;
    line-height: 61px;
    padding: 21px 42px 32px 42px;
  }

  .signin-button {
    margin-top: 30px;
  }
`;

function Login() {
  useEffect(() => {
    document.title = 'Login';
  }, []);

  return (
    <Container>
      <div className="center-box">
        <div className="logo">ADHUB</div>
        <Alert
          className="alert"
          message="Logged out."
          type="warning"
          showIcon
        />
        <GoogleSignInButton
          className="signin-button"
          onClick={store.user.login}
        />
      </div>
    </Container>
  );
}

export default observer(Login);
